import { amGeometryMultiPolygonSchema, amGeometryPolygonSchema } from 'src/common-services/types/alphamap'
import { z } from 'zod'
import { Position } from '@turf/turf'
export { MapStyle } from 'src/components/map-new/types'

export type TileUrlConfig = {
  url: string
  token: string
  verify: string
}

export type Bounds = {
  center: Position
  northEast: Position
  southWest: Position
}

export type MapTypeId = 'hybrid' | 'roadmap'

export type ShapeDisplayProps<T> = {
  fillColor?: string | null
  fillOpacity?: number | null
  strokeWeight?: number | null
  strokeColor?: string | null
  editable?: boolean
  onChange?: (newShape: T) => void
}

export const polygonWithNameSchema = amGeometryPolygonSchema.extend({
  name: z.string(),
  description: z.string(),
})
export type PolygonWithName = z.infer<typeof polygonWithNameSchema>

export const multiPolygonWithNameSchema = amGeometryMultiPolygonSchema.extend({
  name: z.string(),
  description: z.string(),
})
export type MultiPolygonWithName = z.infer<typeof multiPolygonWithNameSchema>

export const circleSchema = z.object({
  radiusMeters: z.number(),
  center: z.array(z.number()),
})
export const circleWithNameSchema = circleSchema.extend({
  name: z.string(),
  description: z.string(),
})
export type Circle = z.infer<typeof circleSchema>
export type CircleWithName = z.infer<typeof circleWithNameSchema>

export type PositionProp = number[] | google.maps.LatLngLiteral

export type MainMapLayers = 'parcels' | 'parcels-mapbox' | 'pins'

export type Tile = { x: number; y: number; z: number }
